import { defineStore } from 'pinia'
import { ref } from 'vue'
import { getCampaignData } from './useCampaign'
export const useStockInvestmentStore = defineStore('stock-investment', () => {
    const campaignData = getCampaignData()
    const minimumInvestmentType = ref<string>(campaignData.asset_data.minimum_investment_type)
    const price = ref<number>(campaignData.asset_data.price_per_stock)
    const step = ref<number>(campaignData.asset_data.stock_increments)
    const min = ref<number>(campaignData.asset_data.minimum_investment)
    const max = ref<number>(campaignData.asset_data.maximum_total_investment_value)
    const stockNumber = ref<number>(campaignData.asset_data.number_of_stocks)
    const clientInvestmentInShares = ref<number>(0)
    const clientInvestmentInAmount = ref<number>(0)

    return {
        step,
        min,
        max,
        stockNumber,
        price,
        clientInvestmentInShares,
        clientInvestmentInAmount,
        minimumInvestmentType,
    }
})
